import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Expired = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear everything in session storage on load
    sessionStorage.clear();
  }, []);

  const handleContinue = () => {
    navigate("/login");
  };

  return (
    <div className="flex justify-center items-center h-screen bg-teal-500 relative overflow-hidden">
      {/* Background Bubbles */}
      <div className="absolute w-72 h-72 bg-white opacity-10 rounded-full top-10 left-10"></div>
      <div className="absolute w-96 h-96 bg-white opacity-10 rounded-full bottom-10 right-10"></div>
      <div className="absolute w-96 h-96 bg-white opacity-10 rounded-full top-12 center"></div>

      {/* Success Card */}
      <div className="bg-white p-6 rounded-2xl shadow-lg text-center w-96 z-10">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 flex items-center justify-center bg-red-100 rounded-full">
            <span className="text-red-600 text-3xl">✖</span>
          </div>
        </div>
        <h2 className="text-xl font-semibold">Expired</h2>
        <p className="text-gray-600 text-sm mt-2">
          The link has unfortunately expired. Kindly contact the system admin to
          send you a new link.
        </p>
        <button
          className="mt-4 bg-teal-500 text-white px-6 py-2 rounded-lg hover:bg-teal-600 transition"
          onClick={handleContinue}
        >
          Return to Login
        </button>
      </div>
    </div>
  );
};

export default Expired;
